import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, useRevalidator, useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Paper from "Components/UI/Paper";
import { BooksForm } from "Components/books/BooksForm";
import { useBalances } from "Context/Balances";
import { BalanceForm } from "Components/Balance/BalanceForm";
import { getAccountCharts } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function BalanceCard() {
  const { getBalanceById, updateBalance } = useBalances();
  const { balanceId } = useParams();
  const { openSuccess, openError } = usePopupNotificationContext();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState(null);
  const [accountCharts, setAccountCharts] = useState([]);
  const navigate = useNavigate();

  const asyncUpdateBalance = async (body) => {
    const res = await updateBalance(body.Id, body);
    if (res) {
      setFormData({ ...res });
      openSuccess("OK", 3000);
      setEditMode(false);
    } else {
      openError("Något gick fel", 3000);
    }
  };

  const asyncGetBalance = async (id) => {
    const balance = await getBalanceById(id);
    const accountCharts = await getAccountCharts();
    setAccountCharts(accountCharts);
    setFormData({ ...balance });
  };
  useEffect(() => {
    asyncGetBalance(balanceId);
  }, [balanceId]);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  if (!formData) {
    return null;
  }

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Saldo - {formData.Id}
          </Typography>
        </Box>
        <BalanceForm
          formData={formData}
          FORM_MODE={editMode ? "EDIT" : "LOCKED"}
          handleInputChange={handleInputChange}
          accountCharts={accountCharts}
        />

        <Grid
          item
          xs={12}
          sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
        >
          {editMode ? (
            <>
              <Button
                size="small"
                onClick={() => setEditMode(false)}
                sx={{ ml: 1, display: editMode ? "block" : "none" }}
              >
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => asyncUpdateBalance(formData)}
                sx={{ ml: 2 }}
                variant="contained"
              >
                Spara
              </Button>
            </>
          ) : (
            <>
              <Button size="small" onClick={() => navigate(-1)}>
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => setEditMode(true)}
                variant="contained"
                sx={{ ml: 2, display: editMode ? "none" : "block" }}
              >
                Editera
              </Button>
            </>
          )}
        </Grid>
      </Paper>
    </>
  );
}
